import { createContext, PropsWithChildren } from 'react';

import { LayoutContextData } from '@/types/ssr';

export const LayoutContext = createContext<LayoutContextData | null>(null);

export function LayoutContextProvider({ children, layoutWrapperRef }: PropsWithChildren<LayoutContextData>) {
  return <LayoutContext.Provider value={{ layoutWrapperRef }}>{children}</LayoutContext.Provider>;
}
